import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  pagination: {
    width: '100%',
    backgroundColor: theme.white,
    padding: theme.other.spacing._16,
    display: 'flex',
    gap: theme.other.spacing._32,
    boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.15)',
    zIndex: 1,

    '@media (max-width: 768px)': {
      justifyContent: 'space-between',
    },
  },
  paginationContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 0,
    border: `1px solid ${theme.colors.gray2[0]}`,
    maxWidth: '300px',
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '4px',

    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  paginationRange: {
    padding: theme.other.spacing._8,
    borderRight: `1px solid ${theme.colors.gray2[0]}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    '@media (max-width: 768px)': {
      borderRight: 'none',
    },
  },
  paginationButton: {
    lineHeight: 1,
    padding: theme.other.spacing._8,
  },
  perPage: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,

    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
}));

export default useStyles;
